import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import BackendAdapter from 'i18next-multiload-backend-adapter';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import Backend from 'i18next-chained-backend';
import config from 'config';
import languages from './languages';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: config.isDevelopment,
    backend: {
      backends: [
        new BackendAdapter(null, {
          backend: HttpApi,
          backendOption: {
            loadPath: `${config.apiUrl}/apis/v2/translations`,
          },
        }),
      ],
      backendOptions: [],
    },
    supportedLngs: languages.map((x) => x.key),
    fallbackLng: 'en',

    interpolation: {
      escapeValue: false,
    },
    parseMissingKeyHandler: (key) => {
      if (typeof key === 'string' && key.length > 0) {
        const capitalized = key.charAt(0).toUpperCase() + key.slice(1);
        return capitalized.split('_').join(' ');
      }
      return key;
    },
  });

export default i18n;
